module.exports = __webpack_public_path__ + "7dd1ba9804547f18f8224e6784b1569e.pdf";